import React from "react";

const GOTHIC_Q_PATH =
  "M1.8 13.45C1.8 16.51 3.08 19.14 5.34 20.63C6.64 21.51 8.05 21.94 9.62 21.94C11.8 21.94 13.88 21.19 15.84 19.7C16.83 20.53 17.49 21.27 17.89 21.94L18.37 22.6L22.2 20.1L21.8 19.57L21.54 19.73C21.03 20.15 20.53 20.37 19.99 20.37C19.91 20.37 19.86 20.37 19.78 20.34H19.67C19.43 20.23 19.12 19.94 18.69 19.49C18.32 19.04 17.89 18.64 17.39 18.29C17.68 18.02 18.13 17.47 18.77 16.62C20.18 14.51 20.87 12.25 20.87 9.86C20.87 6.8 19.62 4.19 17.36 2.7C16.06 1.83 14.62 1.4 13.02 1.4H12.55L12.44 1.43H12.39C10.66 2.17 8.95 4.14 8.95 5.2C8.95 5.9 8.95 7.2 8.98 9.09C9.01 11 9.01 12.31 9.01 13.02C9.01 13.16 9.01 13.34 9.03 13.64V14.25C9.03 15.6 8.87 16.64 8.53 17.36C10.55 16.43 11.37 15.29 11.37 13.05V4.96C11.35 4.86 11.35 4.78 11.35 4.7C11.32 4.57 11.32 4.43 11.32 4.27C11.32 3.71 11.4 3.21 11.53 2.78C12.25 2.97 13.05 3.45 13.88 4.19V16.93C13.48 16.88 13.18 16.85 13 16.85C11.22 16.85 9.59 17.71 9.19 18.56C9.09 18.82 9.03 19.04 9.03 19.22C9.03 19.43 9.06 19.59 9.14 19.73C6.99 17.95 5.5 14.7 5.5 10.9C5.5 7.76 6.85 4.8 9.54 2.06C7.33 2.94 5.44 4.49 3.93 6.69C2.52 8.85 1.8 11.11 1.8 13.45ZM14.7 5.12C15.6 6.35 16.27 7.81 16.69 9.54C16.51 9.81 16.27 9.94 15.92 9.94C15.26 9.94 14.86 9.49 14.7 8.61ZM14.7 9.83C14.99 10.23 15.42 10.44 15.92 10.44C16.22 10.44 16.54 10.34 16.85 10.1C17.04 10.6 17.12 11.53 17.12 12.86C16.8 12.41 16.4 12.17 15.92 12.17C15.42 12.17 14.99 12.36 14.7 12.76ZM14.7 14.01C14.7 13.13 15.21 12.65 15.92 12.65C16.51 12.65 16.91 13.05 17.09 13.85C17.04 15.23 16.75 16.51 16.24 17.65C15.39 17.33 14.89 17.15 14.7 17.09ZM9.67 19.46C9.67 18.69 10.74 18.05 12.36 17.97H12.47C12.81 17.97 13.29 18.1 13.88 18.37V20.47C13.21 20.76 12.63 20.92 12.07 20.92C10.9 20.92 9.67 20.31 9.67 19.46ZM14.7 19.86V18.82C14.73 18.85 14.78 18.9 14.91 18.98L15.26 19.28Z";

export default function QuestLetterIcon({
  size = 24,
  color = "currentColor",
  strokeWidth: _strokeWidth,
  onClick,
  className,
  style = {},
  ...rest
}) {
  const mergedStyle = Object.assign(
    { width: size, height: size, cursor: onClick ? "pointer" : undefined },
    style
  );

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={color}
      stroke="none"
      onClick={onClick}
      className={className}
      style={mergedStyle}
      aria-hidden={rest["aria-label"] ? undefined : true}
      {...rest}
    >
      <path d={GOTHIC_Q_PATH} />
    </svg>
  );
}
